import {
  GoADropdown,
  GoADropdownItem,
  GoAFormItem,
  GoAInput,
  GoAInputDate,
  GoASpacer,
} from '@abgov/react-components';

import React from 'react';

interface PersonProps {
  firstName: string;
  setFirstName: (value: string) => void;
  lastName: string;
  setLastName: (value: string) => void;
  sex: string;
  setSex: (value: string) => void;
  dateOfBirth: string;
  setDateOfBirth: (value: string) => void;
  firstNameErrorMessage: string;
  setFirstNameErrorMessage: (value: string) => void;
  lastNameErrorMessage: string;
  setLastNameErrorMessage: (value: string) => void;
  dateOfBirthErrorMessage: string;
  setDateOfBirthErrorMessage: (value: string) => void;
}

export const PersonComponent = ({
  firstName,
  setFirstName,
  lastName,
  setLastName,
  sex,
  setSex,
  dateOfBirth,
  setDateOfBirth,
  firstNameErrorMessage,
  setFirstNameErrorMessage,
  lastNameErrorMessage,
  setLastNameErrorMessage,
  dateOfBirthErrorMessage,
  setDateOfBirthErrorMessage,
}: PersonProps) => {
  return (
    <div
      style={{
        width: '343px',
        display: 'flex',
        flexDirection: 'column',
        gap: 'var(--goa-space-m)',
      }}
    >
      <div
        style={{ width: '345px', display: 'flex', gap: 'var(--goa-space-m)' }}
      >
        <div style={{ flex: 1, maxHeight: '32px' }}>
          <GoAFormItem
            label="First name"
            error={
              firstNameErrorMessage.length > 0 ? firstNameErrorMessage : ''
            }
          >
            <GoAInput
              name="firstName"
              type="text"
              value={firstName}
              width="100%"
              maxLength={30}
              error={firstNameErrorMessage.length > 0}
              onChange={(_, value) => {
                setFirstName(value);
                setFirstNameErrorMessage('');
              }}
            />
          </GoAFormItem>
        </div>
        <div style={{ flex: 1, maxHeight: '32px' }}>
          <GoAFormItem
            label="Last name"
            error={lastNameErrorMessage.length > 0 ? lastNameErrorMessage : ''}
          >
            <GoAInput
              name="lastName"
              type="text"
              value={lastName}
              width="100%"
              maxLength={30}
              error={lastNameErrorMessage.length > 0}
              onChange={(_, value) => {
                setLastName(value);
                setLastNameErrorMessage('');
              }}
            />
          </GoAFormItem>
        </div>
      </div>
      <GoASpacer vSpacing="2xl" />
      <div
        style={{ width: '345px', display: 'flex', gap: 'var(--goa-space-m)' }}
      >
        <div style={{ flex: 1, maxHeight: '32px' }}>
          <GoAFormItem label="Sex" labelSize="regular">
            <GoADropdown
              name="gender"
              value={sex}
              width="100%"
              onChange={(_, value) => {
                if (value) {
                  setSex(value as string);
                }
              }}
              placeholder="—Select—"
              relative={true}
            >
              <GoADropdownItem value="1" label="Male"></GoADropdownItem>
              <GoADropdownItem value="2" label="Female"></GoADropdownItem>
              <GoADropdownItem value="3" label="Unknown"></GoADropdownItem>
              <GoADropdownItem value="4" label="Other"></GoADropdownItem>
            </GoADropdown>
          </GoAFormItem>
        </div>
        <div style={{ flex: 1, maxHeight: '32px' }}>
          <GoAFormItem
            label="Date of birth"
            labelSize="regular"
            helpText="for example -YYYY-MM-DD"
            error={
              dateOfBirthErrorMessage.length > 0 ? dateOfBirthErrorMessage : ''
            }
          >
            <GoAInputDate
              name="dobPicker"
              value={dateOfBirth ? new Date(dateOfBirth) : undefined}
              max={new Date()}
              width="100%"
              error={dateOfBirthErrorMessage.length > 0}
              onChange={(_, value) => {
                if (value) {
                  const dob = new Date(value);
                  setDateOfBirth(dob.toISOString());
                }
                setDateOfBirthErrorMessage('');
              }}
            />
          </GoAFormItem>
        </div>
      </div>
    </div>
  );
};
